import React from "react"
import { Link, useLocation } from "react-router-dom"
import { Home, MessageSquareText, Store, UsersRound } from "lucide-react"
import { useAuth0 } from "@auth0/auth0-react"
import { NotificationBell } from "./SignalR/NotificationBell"

const navItems = [
  { label: "Home", to: "/", icon: Home, exact: true },
  { label: "Groups", to: "/fetch-groups", icon: UsersRound },
  { label: "Forum", to: "/forum", icon: MessageSquareText },
  { label: "Market", to: "/marketplace", icon: Store },
  { label: "Alerts", to: "/notifications", notifications: true },
]

const isActiveItem = (pathname, item) => {
  if (item.exact) {
    return pathname === item.to
  }

  if (item.to === "/marketplace") {
    return pathname.startsWith("/marketplace")
      || pathname.startsWith("/for-sale")
      || pathname.startsWith("/services")
      || pathname.startsWith("/jobs")
      || pathname.startsWith("/real-estate")
  }

  if (item.to === "/fetch-groups") {
    return pathname.startsWith("/fetch-groups")
      || pathname.startsWith("/group-members")
      || pathname.startsWith("/groups")
  }

  return pathname.startsWith(item.to)
}

export default function MobileBottomNav() {
  const { isAuthenticated } = useAuth0()
  const location = useLocation()

  if (!isAuthenticated || location.pathname === "/public") {
    return null
  }

  return (
    <nav className="mobile-bottom-nav" aria-label="Primary mobile navigation">
      {navItems.map((item) => {
        const Icon = item.icon
        const active = isActiveItem(location.pathname, item)

        if (item.notifications) {
          return (
            <NotificationBell
              key={item.to}
              triggerClassName="mobile-bottom-nav__item mobile-bottom-nav__item--button"
              triggerLabel={item.label}
              dropdownPlacement="bottom-nav"
            />
          )
        }

        return (
          <Link
            key={item.to}
            to={item.to}
            className={`mobile-bottom-nav__item${active ? " active" : ""}`}
            aria-current={active ? "page" : undefined}
          >
            <Icon size={19} aria-hidden="true" />
            <span>{item.label}</span>
          </Link>
        )
      })}
    </nav>
  )
}
